// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable guard-for-in */
import EventHandler from '../../utils/dom/event-handler';
import { Events } from '../../utils/dom/html-events';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';
import FormGenerator, { FormTypes } from '../../components/FormGenerator';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import Manipulator from '../../utils/dom/manipulator';
import { scrollToTop } from '../../utils/misc';

const SELECTOR_WRAPPER = '.p-competition-eligibility-form';
const SELECTOR_FORM_WRAPPER = '.p-competition-eligibility-form__container';
const SELECTOR_FORM = '.p-competition-eligibility-form__form';
const SELECTOR_FORM_BUTTON = '.p-competition-eligibility-form__button';

const IS_LOCAL = false;
const KEY_OBJECT = 'fieldName';
const VALUE_OBJECT = 'value';

class EditCompetitionElegibility {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		this.formWrapper = SelectorEngine.findOne(SELECTOR_FORM_WRAPPER, this._wrapper);
		this.form = SelectorEngine.findOne(SELECTOR_FORM, this.formWrapper);
		this.stepsApi = Manipulator.getDataAttribute(this.form, 'steps-api');
		this.submitApi = Manipulator.getDataAttribute(this.form, 'submit-api');
		this.formButton = SelectorEngine.findOne(SELECTOR_FORM_BUTTON, this._wrapper);
		this._errorContainer = SelectorEngine.findOne('.p-competition-eligibility-form__error-container', this.formWrapper);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this._errorContainer);
		this._successContainer = SelectorEngine.findOne('.p-competition-eligibility-form__success', this._wrapper);
		this._pendingContainer = SelectorEngine.findOne('.p-competition-eligibility-form__pending', this._wrapper);
		this._closeErrorSnackBar.addEventListener('click', () => {
			this._errorContainer.classList.add('u-hidden');
		});
		this.getCompetitionEligibilty = sessionStorage.getItem('competitionEligibilty');
 
		if(!this.getCompetitionEligibilty) {
			this.getFormDetails();
		} else {
			sessionStorage.removeItem('competitionEligibilty');
			window.location.reload();
		}
	}

	async getFormDetails() {
		try {
			const url = this.stepsApi;
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			if (Steps) {
				this.stepsData = Steps;
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				// eslint-disable-next-line no-console
				console.log('Error :', error);
			}
		}
	}

	initiateFormGenerator(stepsData) {
		this.formGenerator = new FormGenerator(this.form, {
			questions: stepsData,
			totalSteps: 1,
			hasSeparator: false,
			formType: FormTypes.SectionForm,
			isHideProgress: true,
			isRenderDependentQuestion: true
		});
		this.formGenerator.onChange((answers) => {
			this.prepareRequestObject(answers);
		});
		EventHandler.on(this.formButton, Events.Click, () => {
			const isFormValid = this.formGenerator.formValidation();
			if (isFormValid) {
				this.submitSupportForm(this.answerList);
			}
		});
	}

	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				this.answerList = {
					...this.answerList,
					...formatObject
				};
			}
		}
	}

	async submitSupportForm(answers) {
		startLoadingAnimation(true);
		const formData = new FormData();

		let payload = {
			genderIdentity: answers.genderIdentity,
			genderatbirth: answers.sexAtBirth ? answers.sexAtBirth : answers.sexAtBirth2,
			competitionGenderCategory: answers.competitionGenderCategory,
            hormoneTreatment: answers.hormoneTreatment
		};
		
		formData.append('json', JSON.stringify(payload));

		if(answers.certificateUpload) {
			formData.append('attachment', answers.certificateUpload[0]);
		}

		const url = this.submitApi;
		const responseData = await Request.postFormData(url, formData);

		const { success, response } = responseData;
		if (success) {
			this.formWrapper.classList.add('u-hidden');
			if(response == '02') {
				this._successContainer.classList.remove('u-hidden');
				sessionStorage.setItem('competitionEligibilty', response);
				this._successContainer.scrollIntoView();
			}
		} else {
			this._errorContainer.classList.remove('u-hidden');
			this._errorContainer.scrollIntoView();
		}
		stopLoadingAnimation(true);	
	}
}

const globalEditCompetitionElegibility = new EditCompetitionElegibility();
export default globalEditCompetitionElegibility;
